import { useHistory } from 'react-router-dom';
import { IoLogOutOutline } from 'react-icons/io5';

// @ld
// @custom
import {
  removeTwoFactorVerified,
  removeSigninEmailNotificationSentFlag
} from 'services/session-storage';
import useUser from 'hooks/use-user';
import { useSignOut } from 'api/auth';
import { organisationsUrl } from 'constants/urls';

import { UnstyledLink } from '@ld/core';
import Box from '@mui/material/Box';

import MenuItems from '../menu-items';
import Logo from '../logo';
import { ASide, Footer, Button, Content } from './styles';

const Sidebar = () => {
  const { setUser } = useUser();
  const history = useHistory();

  const { handleSignOut } = useSignOut({
    onSuccess: () => {
      setUser(null);
      removeTwoFactorVerified();
      removeSigninEmailNotificationSentFlag();
      history.replace('/');
    }
  });

  return (
    <ASide>
      <Box p='30px'>
        <UnstyledLink to={organisationsUrl}>
          <Logo />
        </UnstyledLink>
      </Box>
      <Content>
        {MenuItems.map((Item, index) => (
          <Item key={`sidebar-menu-item-${index}`} />
        ))}
      </Content>
      <Footer>
        <Button
          fullWidth
          startIcon={<IoLogOutOutline size={30} />}
          onClick={() => {
            handleSignOut();
          }}
        >
          Logout
        </Button>
      </Footer>
    </ASide>
  );
};

export default Sidebar;
